import makeStyles from '@material-ui/core/styles/makeStyles';
import { TableCell, Typography } from '@material-ui/core';
import clsx from 'clsx';

import { SIZED_CELL_CLASS } from '../DataTableConstants';

const useStyles = makeStyles({
    root: {
        display: 'block',
        width: '100%',
    },
});

export default function LoadingRow() {
    const classes = useStyles();

    return (
        <TableCell
            className={clsx(SIZED_CELL_CLASS, classes.root)}
            align="left"
            component="div"
            size="small"
            variant="body"
        >
            <Typography variant="caption" component="span" color="textSecondary">
                Loading...
            </Typography>
        </TableCell>
    );
}
